import { CARRIER_ENABLEMENT_SCOPE } from '@klareospace/pharos-lib-types';
import type { CarrierEnablementScope } from '@klareospace/pharos-lib-types';
import { DROPDOWN_FETCH_PAGE_SIZE } from '@klareospace/pharos-lib-front-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

/** Vehicle-search filter for the driver drawer's default-vehicle dropdown. */
export interface VehicleQueryFilter {
  allowedDefaultDriverId?: string;
  carrierEnablementScope: CarrierEnablementScope;
  carrierId?: string;
  enabled: boolean;
  hasNoDefaultDriver: true;
  page: number;
  pageSize: number;
  siteIds?: string[];
  spaceId?: string;
}

// ─── Query builder ────────────────────────────────────────────────────────────

/**
 * Builds the vehicle-search filter for the driver drawer's default-vehicle dropdown. Vehicles
 * are always scoped to the space (so a national/multi-space carrier cannot leak vehicles from
 * other spaces) and to the driver's site context (ANY-of); the carrier filter applies only once
 * a carrier is selected, so site-filtered vehicles appear immediately. Carrier-enablement
 * visibility is resolved space-wide (not site-wide) so a vehicle whose carrier is only enabled
 * on another site of the same space still shows up as a valid default-vehicle candidate.
 */
export function buildVehicleQueryFilter(input: {
  canList: boolean;
  carrierId: string | null | undefined;
  driverId?: string;
  open: boolean;
  siteIds: string[];
  spaceId: string | null;
}): VehicleQueryFilter {
  const siteIds = input.siteIds.length > 0 ? input.siteIds : undefined;
  const carrierId = input.carrierId || undefined;
  const spaceId = input.spaceId ?? undefined;
  return {
    allowedDefaultDriverId: input.driverId,
    carrierEnablementScope: CARRIER_ENABLEMENT_SCOPE.SPACE,
    carrierId,
    enabled: input.open && input.canList && (!!spaceId || !!carrierId || siteIds !== undefined),
    hasNoDefaultDriver: true,
    page: 1,
    pageSize: DROPDOWN_FETCH_PAGE_SIZE,
    siteIds,
    spaceId,
  };
}
